import { gql } from '@apollo/client';

export const PLAN_FRAGMENT = gql`
  fragment PlanDetails on Plan {
    _id
    name
  }
`;
